/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

export var loadingPlaceholder = {
  start: function start(element, size) {
    if (size === void 0) {
      size = 'lg';
    }
    var template = '<div class="kaa-loader-container kaa-loader-' + size + '"><div class="kaa-loader"></div></div>';
    var elements = document.querySelectorAll(element);
    for (var i = 0; i < elements.length; i++) {
      elements[i].innerHTML = template;
    }
    return true;
  },
  finish: function finish(element) {
    var elements = document.querySelectorAll(element);
    for (var i = 0; i < elements.length; i++) {
      var placeholderElement = elements[i].querySelector(".kaa-loader-container");
      placeholderElement == null ? void 0 : placeholderElement.remove();
    }
    return true;
  }
};